import {
  Tabs,
  Tag,
  Modal,
  Button,
  Flex,
  Tooltip,
  Select,
  message,
  Dropdown
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import {
  CheckOutlined,
  BarsOutlined,
  DeleteOutlined,
  HomeOutlined,
  MenuOutlined,
  FolderViewOutlined,
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import moment from "moment";
import commonFn from "@/utils/commonFn";
import { useLocation } from 'react-router-dom';
import { CustomTable, CustomTableExtend, CustomUpload, CustomModal } from "@/hocComponents";
import ParamEditModal from "./ParamEditModal" ;

const MainTable = forwardRef((props, ref) => {
  const location = useLocation();
  const [tabsKey, setTabsKey] = useState(1);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [filePaths, setFilePaths] = useState([]);
  const [selectedList, setSelectedList] = useState([]);

  const [filedModalFlag, setFiledModalFlag] = useState(false);
  const [detailRecord, setDetailRecord] = useState({});
  const [customModalLoading, setCustomModalLoading] = useState(false);

  const controllersRef = useRef([])

  const createController = () => {
    const controller = new AbortController()
    controllersRef.current.push(controller)
    return controller
  }

  const cancelAllRequests = () => {
    controllersRef.current.forEach(c => c?.abort())
    controllersRef.current = []
  }
  
  const initTableHead = {
    vendorName: null,
    requestNo: null,
    addressCity: null,
    jobs: null,
    glAcct: null,
    quotedAmount: null,
    payAmount: null,
    payRemark: null,
    supervisor: null,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn, pageSize: 100})
  }

  const initColumns = [
    {
      title: "Vendor Name",
      dataIndex: "vendorName",
      titleType: "Input",
      width: 160,
      onChange: (e) => tableFilterFn(e, "vendorName"),
    },
    {
      title: "Job Status",
      dataIndex: "jobStatus",
      titleType: "",
      render: (text, record) => {
        const colorMatch = {
          'Ready To Pay': '#00a65a',
          'Sent to Check Approval': '#3c8dbc',
          'Rejected': '#dd4b39',
          'Approved to Print': '#2563EB',
          'Do not Pay': '#71baeb',
        }
        return (
          <a onClick={() => {
            const route = "/AccountPayable/MaintenancePayContractor/Details";
            const paramString = new URLSearchParams(record).toString();
            const url = `${window.location.origin}#${route}?${paramString}`;
            console.log(url);
            
            window.open(url, "_blank", "noopener,noreferrer");
          }}>
            <Tag
              color={colorMatch[text] || "#ccc"}
              style={{
                color: "#fff",
                borderRadius: "4px",
                padding: "0 8px",
              }}
            >
              {text}
            </Tag>
          </a>
        )
      },
    },
    {
      title: "Request No",
      dataIndex: "requestNo",
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "requestNo"),
    },
    {
      title: "Unit Address, City",
      dataIndex: "addressCity",
      titleType: "Input",
      width: 120,
      onChange: (e) => tableFilterFn(e, "addressCity"),
    },
    {
      title: "Job Type",
      dataIndex: "jobs",
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "jobs"),
      render: (text) => {
        return (
          <Flex
            gap="4px 0"
            wrap
            justify="center"
            align="center"
            style={{ width: "100%", textAlign: "center" }}
          >
            {(text || [])?.map((item) => (
              <Tooltip title={item} classNames="my-tooltip">
                <Tag
                  color="#2563EB"
                  style={{
                    color: "#ffffff",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {item}
                </Tag>
              </Tooltip>
            ))}
          </Flex>
        );
      },
    },
    {
      title: "GL Acct",
      dataIndex: "glAcct",
      titleType: "Input",
      width:80,
      onChange: (e) => tableFilterFn(e, "glAcct"),
      render: (text, record) => {
        return (
          <Tooltip title="Select GL Acct">
            <Button
              type="link"
              icon={text ? null : <BarsOutlined />}
              onClick={() => handleMenuClick({key: 'changeAcctAndAmount'}, record)}
            >
              {text ? text : ''}
            </Button>
          </Tooltip>
        )
      },
    },
    {
      title: "Quoted Amount",
      dataIndex: "quotedAmount",
      titleType: "Input",
      isAmountFlag: true,
      width: 120,
      onChange: (e) => tableFilterFn(e, "quotedAmount"),
    },
    {
      title: "Pay Amount",
      dataIndex: "payAmount",
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "payAmount"),
      render: (text, record) => {
        return (
          <span
            style={tabsKey === 1 ? { color: "#1890ff", cursor: "pointer" } : {}}
            onClick={() => {
              if(tabsKey === 1){
                handleMenuClick({key: 'changeAcctAndAmount'}, record)
              }
            }}
          >
            {commonFn.amountToDollarFn(text)}
          </span>
        );
    },
    },
    {
      title: "Pay Remark",
      dataIndex: "payRemark",
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "payRemark"),
    },
    {
      title: "Pay Status",
      dataIndex: "vpStatus",
      titleType: "",
      hidden: tabsKey === 1,
      render: (text, record) => {
        return (
          <a onClick={() => {
            const route = "/AccountPayable/MaintenancePayContractor/Details";
            const paramString = new URLSearchParams(record).toString();
            const url = `${window.location.origin}#${route}?${paramString}`;
            console.log(url);
            
            window.open(url, "_blank", "noopener,noreferrer");
          }}>
            {text}
          </a>
        )
        // const vpstatusMatch = {
        //   "Ready To Pay": "#00a65a",
        //   "Sent to Approval Summary": "#3c8dbc",
        //   "Sent to Check Approval": "#3c8dbc",
        //   "Rejected": "#dd4b39",
        //   "Approved to Print": "#2563EB",
        //   "Do not Pay": "#2563EB",
        //   "Printed": "#2563EB",
        //   "Check Voided": "#2563EB",
        // }
        // return (
        //   <Tag
        //     onClick={(e) => console.log(record)}
        //     color={vpstatusMatch[text]}
        //     style={{
        //       cursor: "pointer",
        //       color: "#fff",
        //       borderRadius: "4px",
        //       padding: "0 8px",
        //     }}
        //   >
        //     {text}
        //   </Tag>
        // );
      },
    },
    {
      title: "Supervisor",
      dataIndex: "supervisor",
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "supervisor"),
    },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 100,
    total: 0,
  });

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    const controller = createController()
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      status: tabsKey,
      vendorId: new URLSearchParams(location.search).get("vendorId"),
      ...tableHead,
    };
    const response = await http.get(api.gardenerAPMaitanceList, {params}, {signal: controller.signal});
    if(!response) return
    if (response && response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const initColunmsFn = () => {
    setPagination({
      current: 1,
      pageSize: 100,
      total: 0,
    })
    setTableList([])
    setSelectedList([])
    setTableHead(initTableHead);
    setColumns(initColumns);
    cancelAllRequests()
  }

  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 100)
  }, [refreshKey])

  const customModalRef = useRef(null);
  const [customModalConfig, setCustomModalConfig] = useState({
    width: 500,
  });

  const paramEditModalRef = useRef(null);
  const [paramEditRecord, setParamEditRecord] = useState({});

  const handleMenuClick = async (item, record) => {
    const { key } = item
    if (["send"].includes(key)) {
      if(!selectedList.length) return message.warning("Please select at least one item") ;
        setCustomModalConfig({
          ...customModalConfig,
          content: `Are you sure to send for approval ${selectedList.length} check(s).`,
          onOkFn: sendForApprovalFn
        })
        customModalRef.current.openModalFn()
      return;
    } else if(["changeAcctAndAmount"].includes(key)){
      setParamEditRecord(record)
      paramEditModalRef.current.openModal(true)
    }
  }

  const paramEditModalSubmitlFn = () => {
      getTableListFn(pagination.current, pagination.pageSize, tableHead)
  }

  const sendForApprovalFn = async() => {
    setCustomModalLoading(true)
    const response = await http.get(api.gardenerSendToVendorPayment, {params: {idList: String(selectedList.map(item => item.id))}});
    if (response.code === "1") {
      message.success("Send for approval successfully");
      MPAPModalSubmitFn()
    } else {
      setTimeout(() => {
        commonFn.modalFailedFn(response)
      }, 500);
    }
    setCustomModalLoading(false)
  }

  const MPAPModalSubmitFn = () => {
    setSelectedList([])
    setTableHead(pre => {
      getTableListFn(pagination.current, pagination.pageSize, pre)
      return pre
    })
  }

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('Download') && 'download']}
      >
        <Tabs 
          defaultActiveKey={tabsKey} 
          items={[
            {key: 1, label: "Ready To Pay"},
            {key: 2, label: "Payments"},
          ]}
          onChange={key => (setTabsKey(key), setRefreshKey(+new Date()))}
        />
      </CustomTableExtend>

      {
        tabsKey === 1 && [{
          name: 'Send For Approval',
          key: 'send',
          type: 'primary',
          icon: <CheckOutlined />,
        }]?.map(item => (
          <commonFn.BtnAuthorityFn authKey={item.key}>
            <Button type={item.type} style={{marginBottom: 20, marginRight: 20, display: 'inline'}} onClick={() => handleMenuClick(item)} loading={customModalLoading}>
              {item?.icon}
              {item?.name}
            </Button>
          </commonFn.BtnAuthorityFn>
        )) || null
      }

      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={[1].includes(tabsKey) && {
          preserveSelectedRowKeys: true,
          type: "checkbox ",
          selectedRowKeys: selectedList.map(item => item.id),
          getCheckboxProps: (record) => ({
            disabled: record.status === 2 || !record?.glAcct,
          }),
          onChange: (selectedRowKeys, selectedRows) => {
            setSelectedList(selectedRows);
          },
        } || false}
        rowKey="id"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="380px"
      />

      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <HomeOutlined style={{ marginRight: "8px" }} />
            File
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={filedModalFlag}
        onCancel={() => setFiledModalFlag(false)}
        footer={null}
        maskClosable={false}
        // destroyOnClose={true}
        width="80%"
      >
      <div
        key={detailRecord?.id}
        style={{ height: "100%", display: "flex", flexDirection: "column" }}
      >
        <CustomUpload
          setFilePaths={setFilePaths} 
          filePaths={filePaths} 
          setBtnDisabled={setBtnDisabled}
          btnDisabled={btnDisabled}
          isEdit={true}
          vendorPaymentId={detailRecord?.id || undefined}
          foreignId={detailRecord?.id || undefined}
          preCalFile={detailRecord?.preCalFile || undefined}
          type={detailRecord?.type || undefined}
          customConfig={{
            pdfHeight: '62vh',
            noShowUpload: true,
            noSubmitBtn: true,
            pageName: 'CheckApproval'
          }}
        />
        <div style={{textAlign: 'center', marginTop: 20}}>
          <Button onClick={() => setFiledModalFlag(false)}>
            cancel
          </Button>
        </div>
      </div>
      </Modal>

      <CustomModal
        ref={customModalRef}
        customConfig={customModalConfig} 
      />

      {/* 部分参数修改 */}
      <ParamEditModal 
        ref={paramEditModalRef}
        record={paramEditRecord}
        paramEditModalSubmitlFn={(params) => paramEditModalSubmitlFn()}
      />
      
    </div>
  );
});
export default MainTable;